// import logo from './logo.svg';
// import './App.css';
import React from 'react';
import Navbar from './components/inc/Navbar';
import Home from './components/pages/Home';
import Policy from './components/pages/Policy';
import Terms from './components/pages/Terms';

import About from './components/pages/About';
import Contact from './components/pages/Contact';
import Footer from './components/inc/Footer';
// import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

function App() {
  return (
    // <div className="App">
    //   <header className="App-header">
    //     <img src={logo} className="App-logo" alt="logo" />
    //     <h1>hello all</h1>
    //     <p>Edit <code>src/App.js</code> and save to reload.</p>
    //     <a
    //       className="App-link"
    //       href="https://reactjs.org"
    //       target="_blank"
    //       rel="noopener noreferrer"
    //     >
    //       Learn React
    //     </a>
    //   </header>
    // </div>
    <Router>
    <div>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/privacy-policy" element={<Policy />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/terms" element={<Terms />} />
      </Routes>
      <Footer />
    </div>
  </Router>
  );
}

export default App;
